import clsx from 'clsx'
import React, { useEffect } from 'react'
import { BarChartOutlined } from "@ant-design/icons";
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import { AuthStore } from '@/utils/store/auth';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';
import {sendMessage} from "@/utils/slsClient";
import {handleError} from "@/utils/ui-helpers";

const SuperButton = () => {
  // 只使用 Supabase 认证状态
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  const { data: authData, isLoading } = useSnapshot(AuthStore);

  useEffect(() => {
    if (supabaseAuth.isAuthenticated && supabaseAuth.user?.email) {
      AuthStore.runFetch(supabaseAuth.user.email);
    } else {
      AuthStore.reset();
    }
  }, [supabaseAuth.isAuthenticated, supabaseAuth.user?.email]);

  // 如果正在加载或不是超级管理员，则不显示按钮
  if (isLoading || !authData?.isSuperAdmin) {
    return null;
  }

  return (
    <>
      <button
        className="btn btn-xs w-17 btn-outline btn-primary"
        onClick={() => {
          window.open("/analysis")
          // try{
          //   throw new Error("px_test")
          // }catch(e){
          //   handleError(e);
          // }
        }}
      >
        <BarChartOutlined style={{ fontSize: "18px" }} className={"pr-1"} />
        分析
      </button>
      {/* <button
          className="btn btn-xs w-17 btn-outline btn-primary"
          onClick={() => {
            sendMessage("test","","")
          }}
      >
        <BarChartOutlined style={{ fontSize: "18px" }} className={"pr-1"} />
        鹏霄测试
      </button> */}
    </>
  )
}

export default SuperButton
